<template>
  <div></div>
</template>

<script>
export default {
  name: "FooterNr1"
}
</script>

<style scoped>

</style>